  (function () {
    var root = document.querySelector('[class*="main-product-"]') || document.querySelector('.main-product');
    if (!root) return;

    var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
    /* Share button */
    var shareBtn = root.querySelector('.custom-share-btn');
    if (shareBtn) {
      shareBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(window.location.href);
        }
      });
    }

    // Bail out if the form is missing (non-product template reusing the section)
    if (!form) return;

    // Hidden <input name="id"> holds the matched variant id
    var variantIdInput = form.querySelector('input[name="id"]');
    if (!variantIdInput) return;

    /* Quantity stepper */
    var qtyDisplay = root.querySelector('[data-qty-display]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');

    function setQty(n) {
      n = Math.max(1, parseInt(n, 10) || 1);
      if (qtyDisplay) qtyDisplay.value = n;
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty((parseInt(qtyDisplay.value, 10) || 1) - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty((parseInt(qtyDisplay.value, 10) || 1) + 1); });
    if (qtyDisplay) qtyDisplay.addEventListener('change', function () { setQty(qtyDisplay.value); });

    /* Thumbnail switcher */
    var thumbs = root.querySelectorAll('[data-thumb-src]');
    var mainImage = root.querySelector('[id^="MainProductImage-"]') || document.getElementById('MainProductImage-' + (root.dataset.sectionId || ''));

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        var thumbTrack = btn.closest('[data-thumbs-track]') || btn.parentElement;
        if (thumbTrack && thumbTrack.scrollLeft !== undefined) {
          try {
            var tLeft = btn.offsetLeft - (thumbTrack.clientWidth / 2) + (btn.clientWidth / 2);
            if (typeof thumbTrack.scrollTo === 'function') thumbTrack.scrollTo({ left: tLeft, behavior: 'smooth' });
            else thumbTrack.scrollLeft = tLeft;
          } catch (e) {}
        }
        if (mainImage) {
          mainImage.src = btn.getAttribute('data-thumb-src');
          mainImage.alt = btn.getAttribute('data-thumb-alt');
        }
        var zoomWrap = mainImage && mainImage.closest('.custom-product-image-zoom');
        if (zoomWrap) {
          var hires = btn.getAttribute('data-thumb-hires');
          if (hires) zoomWrap.setAttribute('data-high-res-img', hires);
          if (mainImage) {
            mainImage.style.transformOrigin = '50% 50%';
            mainImage.classList.remove('is-zoomed');
          }
        }
      });
    });

    /* Element references */
    var variantRadios = root.querySelectorAll('[class*="__variant-radio"]');
    var variantLabels = root.querySelectorAll('[class*="__variant-option"], [class*="__color-swatch-option"]');
    var pickedLabels  = root.querySelectorAll('[data-variant-picked]');
    var priceCurrent  = root.querySelector('[data-price-current]');
    var priceCompare  = root.querySelector('[data-price-compare]');
    var priceDiscount = root.querySelector('[data-price-discount]');
    var addToCartBtn  = root.querySelector('[id^="AddToCart-"]');
    var addToCartText = root.querySelector('[id^="AddToCartText-"]');
    var isPreOrder    = addToCartBtn && addToCartBtn.getAttribute('data-preorder') === 'true';

    /* Scope pair detection to this form so Complete The Set modals and
       cross-sell cards inside root cannot produce false positives. */
    var pairContainer      = form.querySelector('[data-pair-selection]');
    var setRadhaCheckbox   = form.querySelector('#set-radha');
    var setKrishnaCheckbox = form.querySelector('#set-krishna');
    var hasCustomSet       = !!(pairContainer && setRadhaCheckbox && setKrishnaCheckbox);

    /* Common helpers (shared across both branches) */
    function syncVariantVisual() {
      variantLabels.forEach(function (label) {
        var radio = document.getElementById(label.getAttribute('for'));
        var isActive = radio && radio.checked;
        label.classList.toggle('is-active', isActive);
        label.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
    }

    function syncPickedLabels() {
      pickedLabels.forEach(function (el) {
        var optName = el.getAttribute('data-variant-picked');
        if (!optName) return;
        var checked = root.querySelector(
          '[class*="__variant-radio"][data-option-name="' + CSS.escape(optName) + '"]:checked'
        );
        if (!checked) return;
        var value = checked.value;
        /* Append unit for numeric size options if needed */
        if ((optName || '').toLowerCase().trim() === 'size' &&
            value && /^\d+$/.test(value.trim())) {
          value = value + ' Inch';
        }
        el.textContent = value;
      });
    }

    /* Build {1:"12", 2:"Red"} map from checked radios. */
    function getSelectedByIndex() {
      var map = {};
      if (!variantRadios || !variantRadios.length) return map;
      variantRadios.forEach(function (radio) {
        if (!radio.checked) return;
        var idx = parseInt(radio.getAttribute('data-option-index') || '0', 10);
        if (idx > 0) map[idx] = radio.value;
      });
      return map;
    }

    function formatMoney(cents) {
      cents = Math.round(Number(cents) || 0);
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var raw = (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents)
        : '₹' + parts.join('.');
      // Mirrors Liquid's money_without_trailing_zeros so SSR and JS prices match
      return raw.replace(/\.00(?=\s|$|[^\d])/, '');
    }

    function showToast(message, opts) {
      var toast = root.querySelector('[data-cart-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.toggle('is-error', !!(opts && opts.error));
      toast.classList.add('is-visible');
      clearTimeout(toast.__t);
      toast.__t = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2400);
    }

    /* Render price + compare + discount for a single matched variant */
    function renderVariantPrice(price, compare) {
      var priceEl = root.querySelector('.price-item--regular');
      if (priceEl) priceEl.innerHTML = formatMoney(price);
      if (priceCurrent) priceCurrent.innerHTML = formatMoney(price);
      var hasDiscount = compare && compare > price && compare > 0;
      if (priceCompare) {
        if (hasDiscount) {
          priceCompare.innerHTML = formatMoney(compare);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (priceDiscount) {
        if (hasDiscount) {
          var pct = Math.round((compare - price) * 100 / compare);
          priceDiscount.textContent = '(' + pct + '% OFF)';
          priceDiscount.style.display = '';
        } else {
          priceDiscount.style.display = 'none';
        }
      }
    }

    /* Update ATC button availability/text from a single boolean. */
    function renderATC(enabled, soldOut) {
      if (!addToCartBtn) return;
      if (!enabled) {
        addToCartBtn.setAttribute('disabled', '');
        addToCartBtn.disabled = true;
        var soldText = soldOut ? 'Sold Out' : 'Select at least one Poshak';
        if (addToCartText) addToCartText.textContent = soldText;
        if (typeof mutateStickyATC === 'function') mutateStickyATC(false, soldText);
        return;
      }
      if (typeof updateSmartATCButton === 'function') {
        updateSmartATCButton();
      } else {
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.disabled = false;
        if (addToCartText) addToCartText.textContent = isPreOrder ? 'Pre-Order' : 'Add To Cart';
      }
    }

    /* BRANCH 1 - STANDARD PRODUCT: plain Shopify variant matching */
    function findStandardVariant() {
      if (!productVariants || !productVariants.length) return null;
      var selected = getSelectedByIndex();
      var keys = Object.keys(selected);
      /* No radios checked AND no variants at all  bail. */
      if (!keys.length) {
        // No radios rendered (single-variant) or nothing selected yet
        return productVariants[0];
      }
      for (var i = 0; i < productVariants.length; i++) {
        var v = productVariants[i];
        var match = true;
        for (var j = 0; j < keys.length; j++) {
          var idx = parseInt(keys[j], 10);
          if (v['option' + idx] !== selected[idx]) { match = false; break; }
        }
        if (match) return v;
      }
      /* No exact match - return first variant so price + ATC never break. */
      return productVariants[0];
    }

    function syncVariantMedia(v, checkedRadio) {
      var mediaId = null;
      var imageSrc = null;

      if (checkedRadio) {
        mediaId = checkedRadio.getAttribute('data-media-id');
        imageSrc = checkedRadio.getAttribute('data-image-src');
      }

      if (!mediaId && v) {
        if (v.featured_media && v.featured_media.id) {
          mediaId = v.featured_media.id;
        } else if (v.featured_image && v.featured_image.id) {
          mediaId = v.featured_image.id;
        }
      }

      if (!imageSrc && v) {
        if (v.featured_image && v.featured_image.src) {
          imageSrc = v.featured_image.src;
        } else if (v.featured_media && v.featured_media.preview_image) {
          imageSrc = v.featured_media.preview_image.src || v.featured_media.preview_image;
        }
      }

      try {
        document.dispatchEvent(new CustomEvent('product:variant:change', {
          detail: {
            variant: v,
            mediaId: mediaId,
            imageSrc: imageSrc
          }
        }));
      } catch (err) { /* noop */ }

      var gallerySlider = root.querySelector('[data-gallery-slider]') || document.querySelector('[data-gallery-slider]');
      if (gallerySlider) {
        var slides = gallerySlider.querySelectorAll('.product-gallery-slide');
        var targetIndex = -1;

        if (mediaId && slides.length > 0) {
          for (var i = 0; i < slides.length; i++) {
            if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
              targetIndex = i;
              break;
            }
          }
        }

        if (targetIndex === -1 && imageSrc && slides.length > 0) {
          var cleanTarget = imageSrc.split('?')[0].replace(/^https?:/, '').split('/').pop();
          for (var j = 0; j < slides.length; j++) {
            var slideImg = slides[j].querySelector('img');
            if (slideImg) {
              var s = (slideImg.currentSrc || slideImg.src || '').split('?')[0].replace(/^https?:/, '').split('/').pop();
              if (cleanTarget && s && (cleanTarget === s || cleanTarget.indexOf(s) !== -1 || s.indexOf(cleanTarget) !== -1)) {
                targetIndex = j;
                break;
              }
            }
          }
        }

        if (targetIndex >= 0) {
          if (typeof gallerySlider.scrollToIndex === 'function') {
            gallerySlider.scrollToIndex(targetIndex);
          } else {
            var targetSlide = slides[targetIndex];
            if (targetSlide) {
              var targetLeft = targetSlide.offsetLeft - gallerySlider.offsetLeft;
              gallerySlider.scrollTo({
                left: targetLeft,
                behavior: 'smooth'
              });
            }
          }

          var dotsWrap = root.querySelector('[data-gallery-dots]') || document.querySelector('[data-gallery-dots]');
          if (dotsWrap) {
            var dots = dotsWrap.querySelectorAll('.dot');
            dots.forEach(function (dot, idx) {
              var isActive = (idx === targetIndex);
              dot.classList.toggle('is-active', isActive);
              dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
          }
        }
      }

      if (mainImage && imageSrc) {
        mainImage.src = imageSrc;
        var zoomWrap = mainImage.closest('.custom-product-image-zoom');
        if (zoomWrap) {
          zoomWrap.setAttribute('data-high-res-img', imageSrc);
        }
      }
    }

    function updatePriceAndATCStandard() {
      var v = findStandardVariant();
      if (!v) {
        // Truly no-variant product: leave the SSR price and block ATC
        renderATC(false, false);
        return;
      }
      if (variantIdInput) variantIdInput.value = v.id;
      renderVariantPrice(v.price, v.compare_at_price);
      renderATC(!!v.available, !v.available);
      syncVariantMedia(v);
    }

    /* BRANCH 2 - PAIR PRODUCT (Radha/Krishna checkboxes): custom multi-item logic */
    var RADHA_SET_VALUE   = 'Radha Rani Poshak';
    var KRISHNA_SET_VALUE = 'Krishna Ji Poshak';

    function findPairVariants() {
      var selectedSize = null;
      var checked = root.querySelector('[class*="__variant-radio"]:checked');
      if (checked) selectedSize = checked.value;

      var radha = null, krishna = null;
      if (productVariants && productVariants.length) {
        for (var i = 0; i < productVariants.length; i++) {
          var v = productVariants[i];
          var matchSize = (selectedSize == null) || (v.option1 === selectedSize || v.option2 === selectedSize || v.option3 === selectedSize);
          if (!matchSize) continue;
          if (!radha && (v.option1 === RADHA_SET_VALUE || v.option2 === RADHA_SET_VALUE || (v.title && v.title.indexOf(RADHA_SET_VALUE) !== -1))) {
            radha = v;
          }
          if (!krishna && (v.option1 === KRISHNA_SET_VALUE || v.option2 === KRISHNA_SET_VALUE || (v.title && v.title.indexOf(KRISHNA_SET_VALUE) !== -1))) {
            krishna = v;
          }
        }
      }
      var radhaOn   = !!(setRadhaCheckbox   && setRadhaCheckbox.checked);
      var krishnaOn = !!(setKrishnaCheckbox && setKrishnaCheckbox.checked);
      var total = 0, compare = 0, available = true, itemsCount = 0;
      if (radhaOn   && radha)   { total += radha.price;   compare += radha.compare_at_price   || 0; available = available && radha.available;   itemsCount++; }
      if (krishnaOn && krishna) { total += krishna.price; compare += krishna.compare_at_price || 0; available = available && krishna.available; itemsCount++; }
      return {
        radha: radha, krishna: krishna,
        radhaOn: radhaOn, krishnaOn: krishnaOn,
        total: total, compare: compare,
        available: available, itemsCount: itemsCount
      };
    }

    function updatePriceAndATCPair() {
      var sel = findPairVariants();

      var radhaPriceEl = root.querySelector('[data-pair-price="radha"]');
      var krishnaPriceEl = root.querySelector('[data-pair-price="krishna"]');
      if (radhaPriceEl && sel.radha) {
        radhaPriceEl.innerHTML = formatMoney(sel.radha.price);
      }
      if (krishnaPriceEl && sel.krishna) {
        krishnaPriceEl.innerHTML = formatMoney(sel.krishna.price);
      }

      if (setRadhaCheckbox) {
        var radhaGroup = setRadhaCheckbox.closest('.checkbox-group');
        if (radhaGroup) radhaGroup.classList.toggle('is-checked', setRadhaCheckbox.checked);
      }
      if (setKrishnaCheckbox) {
        var krishnaGroup = setKrishnaCheckbox.closest('.checkbox-group');
        if (krishnaGroup) krishnaGroup.classList.toggle('is-checked', setKrishnaCheckbox.checked);
      }

      if (sel.itemsCount === 0) {
        var priceEl = root.querySelector('.price-item--regular');
        if (priceEl) priceEl.textContent = '-';
        if (priceCurrent) priceCurrent.textContent = '-';
        if (priceCompare) priceCompare.style.display = 'none';
        if (priceDiscount) priceDiscount.style.display = 'none';
        if (variantIdInput) variantIdInput.value = '';
        renderATC(false, false);
        return;
      }

      renderVariantPrice(sel.total, sel.compare);

      // Legacy no-JS fallback only - the AJAX path does not read this input
      if (variantIdInput) {
        if (sel.radhaOn && sel.radha)            variantIdInput.value = sel.radha.id;
        else if (sel.krishnaOn && sel.krishna)   variantIdInput.value = sel.krishna.id;
        else                                     variantIdInput.value = '';
      }

      renderATC(sel.available, !sel.available);
    }

    /* DEITY FIT GUIDE (Variant Metafield UI Updater) */
    var deityGuideEl   = root.querySelector('[data-deity-fit-guide]');
    var deityCardsEl   = root.querySelector('[data-deity-fit-cards]');
    var deitySizeSpans = root.querySelectorAll('[data-deity-fit-size]');

    function positionDeityGuideArrow() {
      if (!deityGuideEl || deityGuideEl.style.display === 'none') return;
      var arrow = deityGuideEl.querySelector('.deity-fit-guide__arrow');
      if (!arrow) return;

      var activePill = null;
      var sizeGroup = root.querySelector(
        '[data-variant-group*="size" i], [data-variant-group*="height" i], [data-variant-group*="inch" i], [data-variant-group*="no" i]'
      );
      if (sizeGroup) {
        activePill = sizeGroup.querySelector(
          '[class*="__variant-option"].is-active, [class*="__variant-option"][aria-checked="true"]'
        );
      }

      if (!activePill) {
        var sizeRadio = root.querySelector(
          'input[type="radio"][data-option-name*="size" i]:checked, input[type="radio"][data-option-name*="height" i]:checked'
        );
        if (sizeRadio) {
          activePill = root.querySelector('label[for="' + CSS.escape(sizeRadio.id) + '"]');
        }
      }

      if (!activePill) {
        activePill = root.querySelector(
          '[class*="__variant-option"].is-active[data-option-name*="size" i], [class*="__variant-option"].is-active[data-option-name*="height" i]'
        );
      }

      if (!activePill) {
        var allActive = root.querySelectorAll(
          '[class*="__variant-option"].is-active, [class*="__variant-option"][aria-checked="true"]'
        );
        for (var i = allActive.length - 1; i >= 0; i--) {
          var p = allActive[i];
          if (!p.closest('.paired-size-picker-container') && !p.closest('#CompleteTheSetModal') && !p.closest('.quick-view-modal')) {
            activePill = p;
            break;
          }
        }
      }

      if (!activePill) return;

      var pillRect = activePill.getBoundingClientRect();
      var guideRect = deityGuideEl.getBoundingClientRect();

      if (guideRect.width === 0 || pillRect.width === 0) {
        requestAnimationFrame(positionDeityGuideArrow);
        return;
      }

      var pillCenterX = pillRect.left + (pillRect.width / 2);
      var arrowWidth = arrow.offsetWidth || 12;
      var arrowCenterOffset = arrowWidth / 2;

      // Base left of the deity guide container in viewport coordinates (without margin-left)
      var currentMargin = parseFloat(deityGuideEl.style.marginLeft || '0') || 0;
      var naturalLeft = guideRect.left - currentMargin;

      // Available container width
      var parentEl = deityGuideEl.parentElement;
      var parentWidth = parentEl ? parentEl.clientWidth : guideWidth;
      var guideWidth = deityGuideEl.offsetWidth;

      // Calculate adaptive box position: center box under active pill if possible, clamped to container
      var boxLeft = 0;
      if (guideWidth < parentWidth) {
        var pillRelX = pillCenterX - naturalLeft;
        var idealMargin = pillRelX - (guideWidth / 2);
        var maxMargin = Math.max(0, parentWidth - guideWidth);
        boxLeft = Math.max(0, Math.min(idealMargin, maxMargin));
      }
      deityGuideEl.style.marginLeft = Math.round(boxLeft) + 'px';

      // Recompute arrow position relative to the box
      var newGuideLeft = naturalLeft + boxLeft;
      var targetLeft = (pillCenterX - newGuideLeft) - arrowCenterOffset;

      var minLeft = 14;
      var maxLeft = guideWidth - arrowWidth - 14;
      var finalLeft = Math.max(minLeft, Math.min(targetLeft, maxLeft));

      arrow.style.left = Math.round(finalLeft) + 'px';
    }

    function updateDeityFitGuide() {
      if (!deityGuideEl || !deityCardsEl) return;

      var activeVariant = null;
      if (hasCustomSet) {
        var sel = findPairVariants();
        activeVariant = (sel.radhaOn && sel.radha) ? sel.radha : ((sel.krishnaOn && sel.krishna) ? sel.krishna : findStandardVariant());
      } else {
        activeVariant = findStandardVariant();
      }

      if (!activeVariant || !window.deityFitData) {
        deityGuideEl.style.display = 'none';
        return;
      }

      var newVariantId = String(activeVariant.id);
      var fitArray = window.deityFitData[newVariantId];

      if ((!fitArray || !Array.isArray(fitArray) || fitArray.length === 0) && Array.isArray(productVariants)) {
        var activeSizeVal = '';
        var sizeOptIndex = -1;
        variantRadios.forEach(function (r) {
          if (r.checked) {
            var optName = (r.getAttribute('data-option-name') || '').toLowerCase().trim();
            if (optName.indexOf('size') !== -1 || optName.indexOf('height') !== -1) {
              activeSizeVal = r.value;
              sizeOptIndex = parseInt(r.getAttribute('data-option-index') || '0', 10);
            }
          }
        });
        if (!activeSizeVal && activeVariant.option2) {
          activeSizeVal = activeVariant.option2;
          sizeOptIndex = 2;
        } else if (!activeSizeVal && activeVariant.option1) {
          activeSizeVal = activeVariant.option1;
          sizeOptIndex = 1;
        }

        if (activeSizeVal) {
          for (var i = 0; i < productVariants.length; i++) {
            var sib = productVariants[i];
            if (!sib) continue;
            var sibMatch = false;
            if (sizeOptIndex === 1 && sib.option1 === activeSizeVal) sibMatch = true;
            else if (sizeOptIndex === 2 && sib.option2 === activeSizeVal) sibMatch = true;
            else if (sizeOptIndex === 3 && sib.option3 === activeSizeVal) sibMatch = true;
            else if (sib.option1 === activeSizeVal || sib.option2 === activeSizeVal || sib.option3 === activeSizeVal) sibMatch = true;

            if (sibMatch) {
              var sibData = window.deityFitData[String(sib.id)];
              if (sibData && Array.isArray(sibData) && sibData.length > 0) {
                fitArray = sibData;
                break;
              }
            }
          }
        }
      }

      if (!fitArray || !Array.isArray(fitArray) || fitArray.length === 0) {
        deityGuideEl.style.display = 'none';
        return;
      }

      var sizeLabel = activeVariant.option1 || activeVariant.title || '';
      variantRadios.forEach(function (r) {
        if (r.checked) {
          var optName = (r.getAttribute('data-option-name') || '').toLowerCase().trim();
          if (optName.indexOf('size') !== -1 || optName.indexOf('height') !== -1) {
            sizeLabel = r.value;
          }
        }
      });

      deitySizeSpans.forEach(function (span) {
        span.textContent = sizeLabel;
      });

      deityCardsEl.innerHTML = '';

      fitArray.forEach(function (item) {
        var dName = '';
        var dSize = '';
        var imgSrc = '';

        if (typeof item === 'object' && item !== null) {
          dName = (item.name || '').trim();
          dSize = (item.size || '').trim();
          imgSrc = (item.img || '').trim();
        } else if (typeof item === 'string' && item.indexOf('|') !== -1) {
          var parts = item.split('|');
          dName = parts[0].trim();
          dSize = parts[1].trim();
        } else {
          return;
        }

        if (!dName || !dSize) return;

        // Clean Deity Name (do not show collection/design name like Neelam Jyoti, Shyam Kanak, etc.)
        var dNameLower = (dName + ' ' + dSize).toLowerCase();
        var cleanName = dName;
        if (dNameLower.indexOf('radha rani') !== -1 || (dNameLower.indexOf('radha') !== -1 && dNameLower.indexOf('krishna') === -1)) {
          cleanName = 'Radha Rani';
        } else if (dNameLower.indexOf('krishna') !== -1 && dNameLower.indexOf('radha') === -1) {
          cleanName = 'Krishna';
        } else if (dNameLower.indexOf('radha krishna') !== -1 || dNameLower.indexOf('radhakrishna') !== -1) {
          cleanName = 'Radha Krishna';
        } else if (dNameLower.indexOf('mata rani') !== -1 || dNameLower.indexOf('matarani') !== -1) {
          cleanName = 'Matarani';
        } else if (dNameLower.indexOf('gopal') !== -1 || dNameLower.indexOf('laddu') !== -1) {
          cleanName = 'Gopal Ji';
        } else if (dNameLower.indexOf('jagannath') !== -1) {
          cleanName = 'Jagannath Ji';
        } else if (dNameLower.indexOf('shiv') !== -1) {
          cleanName = 'Shiv Parvati';
        } else if (dNameLower.indexOf('ganesh') !== -1) {
          cleanName = 'Ganesh Ji';
        } else if (dNameLower.indexOf('hanuman') !== -1) {
          cleanName = 'Hanuman Ji';
        }

        var dKey = cleanName.toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
        if (!imgSrc && window.deityImageMap) {
          imgSrc = window.deityImageMap[dKey] ||
                   window.deityImageMap[dName.toLowerCase().trim()] ||
                   (dKey === 'radha rani' ? window.deityImageMap['radha'] : null) ||
                   (dKey === 'krishna' ? window.deityImageMap['krishna ji'] : null) ||
                   (dKey === 'matarani' ? (window.deityImageMap['mata rani'] || window.deityImageMap['mata rani idol']) : null) ||
                   (dKey === 'gopal ji' ? (window.deityImageMap['gopal'] || window.deityImageMap['laddu gopal']) : null);
        }

        var card = document.createElement('div');
        card.className = 'deity-fit-card';

        var avatarWrap = document.createElement('div');
        avatarWrap.className = 'deity-fit-card__avatar-wrap';

        if (imgSrc) {
          var img = document.createElement('img');
          img.className = 'deity-fit-card__avatar';
          img.src = imgSrc;
          img.alt = cleanName;
          img.loading = 'lazy';
          avatarWrap.appendChild(img);
        } else {
          var placeholder = document.createElement('div');
          placeholder.className = 'deity-fit-card__avatar deity-fit-card__avatar--placeholder';
          placeholder.textContent = cleanName.charAt(0);
          avatarWrap.appendChild(placeholder);
        }

        var badge = document.createElement('span');
        badge.className = 'deity-fit-card__badge';
        badge.setAttribute('aria-hidden', 'true');
        badge.innerHTML =
          '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M3.2 7.2l2.5 2.5 5.1-5.2" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
        avatarWrap.appendChild(badge);

        var nameEl = document.createElement('span');
        nameEl.className = 'deity-fit-card__name';
        nameEl.textContent = cleanName;

        var sizeEl = document.createElement('span');
        sizeEl.className = 'deity-fit-card__size';

        var rawSize = dSize.trim();

        // Strip bracketed text plus "matarani"/"lehenga" so only the idol size remains
        var cleanedSize = rawSize.replace(/\([^)]*\)/g, '').replace(/matarani/gi, '').replace(/lehenga/gi, '').trim();

        // Fallback if entire size string was inside brackets (e.g. "(12 inch)")
        if (!cleanedSize) {
          cleanedSize = rawSize.replace(/[()]/g, '').replace(/matarani/gi, '').replace(/lehenga/gi, '').trim();
        }

        // Normalize range separators between numbers: "6 - 7", "6–7", "6—7", "6/7" -> "6-7"
        cleanedSize = cleanedSize.replace(/(\d+)\s*[–—\/-]\s*(\d+)/g, '$1-$2');

        // Check if size is specified in "No." / "Number" or if it is a Gopal / Bal Swaroop idol
        var isNoFormat = /no\.?|number|num/i.test(cleanedSize) ||
                         /gopal|bal\s*swaroop|laddu/i.test(cleanName) ||
                         /gopal|bal\s*swaroop|laddu/i.test(dName);

        // Strip text units cleanly including trailing dot
        var numPart = cleanedSize
          .replace(/\b(numbers?|no)\b\.?/gi, '')
          .replace(/\b(inch|inches)\b\.?/gi, '')
          .replace(/["']/g, '')
          .trim();

        var fmtSize = cleanedSize;
        if (/^\d+(\.\d+)?(-\d+(\.\d+)?)?$/.test(numPart)) {
          if (isNoFormat) {
            fmtSize = numPart + ' No.';
          } else {
            fmtSize = numPart + ' Inch';
          }
        } else if (/\bno\.?$/i.test(cleanedSize) || /\bnumbers?$/i.test(cleanedSize)) {
          fmtSize = numPart + ' No.';
        } else if (/\b(inch|inches|")$/i.test(cleanedSize)) {
          fmtSize = numPart + ' Inch';
        }

        sizeEl.textContent = fmtSize;

        card.appendChild(avatarWrap);
        card.appendChild(nameEl);
        card.appendChild(sizeEl);
        deityCardsEl.appendChild(card);
      });

      var cardCount = deityCardsEl.children.length;
      if (cardCount === 0) {
        deityGuideEl.style.display = 'none';
        deityGuideEl.style.marginLeft = '0px';
      } else {
        deityGuideEl.setAttribute('data-deity-count', String(cardCount));
        deityGuideEl.style.display = 'block';
        requestAnimationFrame(positionDeityGuideArrow);
        setTimeout(positionDeityGuideArrow, 50);
      }
    }

    /*
       COMPLETE THE PAIR - CONDITIONAL SIZE PICKER & SMART ATC
 */
    var pairedVariantId = null;
    var matchingPairCb = root.querySelector('#add-matching-pair');
    var pairWrapper = root.querySelector('#MatchingPairContainer');
    var pairedSizePicker = root.querySelector('#PairedSizePickerContainer') || root.querySelector('.paired-size-picker-container');
    var pairedSizePills = root.querySelectorAll('.paired-size-pill');
    var pairedPriceEl = root.querySelector('#MatchingPairPrice');

    function mutateStickyATC(enabled, text) {
      var stickyBtns = document.querySelectorAll('.sticky-atc-button, [data-sticky-atc], .pdp-mobile-bottom-bar button[name="add"], .btn-sticky-add-to-cart');
      stickyBtns.forEach(function (btn) {
        if (enabled) {
          btn.removeAttribute('disabled');
          btn.disabled = false;
        } else {
          btn.setAttribute('disabled', '');
          btn.disabled = true;
        }
        var span = btn.querySelector('[id^="AddToCartText-"]') || btn.querySelector('span:last-child') || btn.querySelector('span');
        if (span) span.textContent = text;
        else      btn.textContent = text;
      });
    }

    var inBtnQtyEl = addToCartBtn ? addToCartBtn.querySelector('.in-btn-qty') : null;
    var inBtnQtyVal = addToCartBtn ? addToCartBtn.querySelector('[data-in-btn-qty-val]') : null;
    var atcDefaultContent = addToCartBtn ? addToCartBtn.querySelector('.atc-btn-default-content') : null;

    function getCurrentPrimaryVariantId() {
      if (hasCustomSet) {
        var sel = findPairVariants();
        var primary = (sel.radhaOn && sel.radha) || (sel.krishnaOn && sel.krishna);
        return primary ? Number(primary.id) : null;
      }
      var v = findStandardVariant();
      var targetId = (v && v.id) || (variantIdInput && variantIdInput.value) || (productVariants && productVariants[0] && productVariants[0].id);
      return targetId ? Number(targetId) : null;
    }

    function renderInBtnQty(quantity) {
      if (!addToCartBtn) return;
      var q = parseInt(quantity, 10) || 0;
      if (q > 0) {
        addToCartBtn.classList.add('is-qty-mode');
        if (inBtnQtyVal) inBtnQtyVal.textContent = q;
        if (inBtnQtyEl) inBtnQtyEl.style.display = 'flex';
        if (atcDefaultContent) atcDefaultContent.style.display = 'none';
        if (qtyDisplay) qtyDisplay.value = q;
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.disabled = false;
      } else {
        revertInBtnQty();
      }
    }

    function revertInBtnQty() {
      if (!addToCartBtn) return;
      addToCartBtn.classList.remove('is-qty-mode');
      if (inBtnQtyEl) inBtnQtyEl.style.display = 'none';
      if (atcDefaultContent) atcDefaultContent.style.display = 'inline-flex';
      if (qtyDisplay) qtyDisplay.value = 1;
      addToCartBtn.removeAttribute('disabled');
      addToCartBtn.disabled = false;
      if (addToCartText) {
        addToCartText.textContent = isPreOrder ? 'Pre-Order' : 'Add To Cart';
      }
      updateSmartATCButton();
    }

    function updateCartQuantity(newQty) {
      var qtyNum = Math.max(0, parseInt(newQty, 10) || 0);
      var ids = [];

      if (hasCustomSet) {
        var sel = findPairVariants();
        if (sel.radhaOn && sel.radha) ids.push(String(sel.radha.id));
        if (sel.krishnaOn && sel.krishna) ids.push(String(sel.krishna.id));
      } else {
        var stdV = findStandardVariant();
        var targetId = (stdV && stdV.id) || (variantIdInput && variantIdInput.value) || (productVariants && productVariants[0] && productVariants[0].id);
        if (targetId) ids.push(String(targetId));
      }

      if (matchingPairCb && matchingPairCb.checked && !matchingPairCb.disabled && pairedVariantId) {
        ids.push(String(pairedVariantId));
      }

      if (!ids.length) {
        var curId = getCurrentPrimaryVariantId();
        if (curId) ids.push(String(curId));
      }

      if (!ids.length) {
        return Promise.reject(new Error('No variant selected'));
      }

      if (ids.length === 1) {
        return postJSON('/cart/change.js', {
          id: ids[0],
          quantity: qtyNum
        }).then(function (res) {
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Could not update cart';
            throw new Error(msg);
          }
          refreshExternalCart();
          return res.data;
        });
      }

      var updates = {};
      ids.forEach(function (id) {
        updates[id] = qtyNum;
      });

      return postJSON('/cart/update.js', {
        updates: updates
      }).then(function (res) {
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not update cart';
          throw new Error(msg);
        }
        refreshExternalCart();
        return res.data;
      });
    }

    function isCurrentProductInCart(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;
      var currentPid = window.currentProductId || (root.dataset.productId ? Number(root.dataset.productId) : null);
      var currentHandle = window.currentProductHandle || (root.dataset.productHandle || '');
      return cart.items.some(function (item) {
        return (Number(item.product_id) === currentPid || item.handle === currentHandle) && item.quantity > 0;
      });
    }

    function syncStateWithCartData(cart) {
      if (!cart || !Array.isArray(cart.items)) return;

      // Sticky ribbon is visible store-wide whenever any product is in the cart
      var totalItems = (typeof cart.item_count === 'number') ? cart.item_count : (Array.isArray(cart.items) ? cart.items.length : 0);
      if (totalItems > 0) {
        showPostAtcStickyBar();
      } else {
        hidePostAtcStickyBar();
      }

      // In-button quantity sync for the currently selected variant
      if (hasCustomSet) {
        var sel = findPairVariants();
        var rId = sel.radha ? String(sel.radha.id) : null;
        var kId = sel.krishna ? String(sel.krishna.id) : null;
        var foundPair = cart.items.find(function (item) {
          return (String(item.id) === rId || String(item.id) === kId) && item.quantity > 0;
        });
        if (foundPair && foundPair.quantity > 0) {
          renderInBtnQty(foundPair.quantity);
        } else {
          revertInBtnQty();
        }
      } else {
        var currentId = getCurrentPrimaryVariantId();
        if (currentId) {
          var found = cart.items.find(function (item) {
            return (String(item.id) === String(currentId) || String(item.variant_id) === String(currentId)) && item.quantity > 0;
          });
          if (found && found.quantity > 0) {
            renderInBtnQty(found.quantity);
          } else {
            revertInBtnQty();
          }
        } else if (!inCart) {
          revertInBtnQty();
        }
      }
    }

    function syncProductWithCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          syncStateWithCartData(cart);
        })
        .catch(function () { /* noop */ });
    }

    var syncButtonWithCart = syncProductWithCart;

    function updateSmartATCButton() {
      if (!addToCartBtn) return;

      // Check main product availability
      var isMainAvailable = true;
      if (hasCustomSet) {
        var curPair = findPairVariants();
        isMainAvailable = curPair.itemsCount > 0 && curPair.available;
      } else {
        var stdV = findStandardVariant();
        isMainAvailable = stdV ? stdV.available : true;
      }

      if (!isMainAvailable) {
        addToCartBtn.classList.remove('is-qty-mode');
        if (inBtnQtyEl) inBtnQtyEl.style.display = 'none';
        if (atcDefaultContent) atcDefaultContent.style.display = 'inline-flex';
        addToCartBtn.setAttribute('disabled', '');
        addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = 'Sold Out';
        mutateStickyATC(false, 'Sold Out');
        return;
      }

      // Complete the pair: checked but no paired variant picked yet
      if (matchingPairCb && matchingPairCb.checked && !matchingPairCb.disabled) {
        if (!pairedVariantId) {
          addToCartBtn.classList.remove('is-qty-mode');
          if (inBtnQtyEl) inBtnQtyEl.style.display = 'none';
          if (atcDefaultContent) atcDefaultContent.style.display = 'inline-flex';
          addToCartBtn.setAttribute('disabled', '');
          addToCartBtn.disabled = true;
          if (addToCartText) addToCartText.textContent = 'Select Size';
          mutateStickyATC(false, 'Select Size');
          return;
        }
      }

      // Unpaired or paired variant picked: revert to "Add to Cart" and re-enable
      if (!addToCartBtn.classList.contains('is-qty-mode')) {
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.disabled = false;
        var normalText = isPreOrder ? 'Pre-Order' : 'Add To Cart';
        if (addToCartText) addToCartText.textContent = normalText;
        mutateStickyATC(true, normalText);
      }
    }

    function syncMatchingPair() {
      var isChecked = Boolean(matchingPairCb && matchingPairCb.checked);

      if (pairWrapper) {
        pairWrapper.classList.toggle('is-active', isChecked);
      }

      if (pairedSizePicker) {
        pairedSizePicker.classList.toggle('is-open', isChecked);
        pairedSizePicker.style.display = isChecked ? 'block' : 'none';
      }

      updateSmartATCButton();

      if (window.ShringarHub && typeof window.ShringarHub.notifyPairSelected === 'function') {
        if (isChecked && pairedVariantId) {
          var activePill = root.querySelector('.paired-size-pill.is-active');
          var pTitle = root.querySelector('.matching-pair-title') ? root.querySelector('.matching-pair-title').textContent.replace('Add matching ', '').trim() : 'Pair';
          var vTitle = activePill ? (activePill.getAttribute('data-variant-title') || activePill.textContent.trim()) : '';
          window.ShringarHub.notifyPairSelected(pairedVariantId, pTitle, vTitle, true);
        } else {
          window.ShringarHub.notifyPairSelected(null, null, null, false);
        }
      }
    }

    if (matchingPairCb) {
      matchingPairCb.addEventListener('change', syncMatchingPair);
    }

    var pairedContainer = root.querySelector('.paired-size-options');
    if (pairedContainer && pairedSizePills && pairedSizePills.length > 0) {
      var hasDetailedTitles = false;
      pairedSizePills.forEach(function (pill) {
        var t = (pill.getAttribute('data-variant-title') || pill.textContent || '').trim();
        var tLow = t.toLowerCase();
        if (t.length > 8 || t.indexOf('/') !== -1 || t.indexOf('-') !== -1 || tLow.indexOf('poshak') !== -1 || tLow.indexOf('krishna') !== -1 || tLow.indexOf('radha') !== -1) {
          hasDetailedTitles = true;
        }
      });
      if (hasDetailedTitles) {
        pairedContainer.classList.add('paired-size-options--detailed-grid');
        pairedContainer.classList.remove('paired-size-options--compact');
      } else {
        pairedContainer.classList.add('paired-size-options--compact');
        pairedContainer.classList.remove('paired-size-options--detailed-grid');
      }
    }

    if (pairedSizePills && pairedSizePills.length > 0) {
      pairedSizePills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          if (pill.disabled || pill.classList.contains('is-disabled')) return;

          var vId = pill.getAttribute('data-variant-id');
          var vPrice = pill.getAttribute('data-variant-price');

          pairedSizePills.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-checked', 'true');

          pairedVariantId = vId;
          if (matchingPairCb) {
            matchingPairCb.setAttribute('data-paired-variant-id', vId);
            matchingPairCb.dataset.pairedVariantId = vId;
          }

          if (pairedPriceEl && vPrice) {
            pairedPriceEl.textContent = '+ ' + formatMoney(vPrice);
            pairedPriceEl.style.display = 'inline-block';
          }

          updateSmartATCButton();

          if (window.ShringarHub && typeof window.ShringarHub.notifyPairSelected === 'function') {
            var isPairActive = Boolean(matchingPairCb && matchingPairCb.checked);
            var pTitle = root.querySelector('.matching-pair-title') ? root.querySelector('.matching-pair-title').textContent.replace('Add matching ', '').trim() : 'Pair';
            var vTitle = pill.getAttribute('data-variant-title') || pill.textContent.trim();
            window.ShringarHub.notifyPairSelected(pairedVariantId, pTitle, vTitle, isPairActive);
          }
        });
      });
    }
    /* MASTER ROUTER - variant-radio and checkbox changes, dispatched by hasCustomSet */
    function updatePriceAndATC() {
      if (hasCustomSet) updatePriceAndATCPair();
      else              updatePriceAndATCStandard();
      updateDeityFitGuide();
      syncMatchingPair();
      syncButtonWithCart();
      if (window.ShringarHub && typeof window.ShringarHub.syncState === 'function') {
        var pairSel = hasCustomSet ? findPairVariants() : null;
        window.ShringarHub.syncState({
          isSet: hasCustomSet,
          radhaOn: pairSel ? pairSel.radhaOn : false,
          radhaVariantId: pairSel && pairSel.radha ? Number(pairSel.radha.id) : null,
          krishnaOn: pairSel ? pairSel.krishnaOn : false,
          krishnaVariantId: pairSel && pairSel.krishna ? Number(pairSel.krishna.id) : null,
          primaryVariantId: getCurrentPrimaryVariantId()
        });
      } else if (typeof window.syncShringarForVariant === 'function') {
        window.syncShringarForVariant(getCurrentPrimaryVariantId());
      }
    }

    /* AJAX ADD-TO-CART. Standard products are handled by the cart-drawer
       submit interceptor; pair products POST {"items":[...]} on click. */
    function postJSON(url, payload) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
      });
    }

    function postAddToCart(itemsToCart) {
      return postJSON('/cart/add.js', { items: itemsToCart });
    }

    function refreshExternalCart() {
      if (window.DamodarCart && typeof window.DamodarCart.refresh === 'function') {
        try { window.DamodarCart.refresh(); } catch (e) { /* noop */ }
      }
      /* Prevent side drawer from auto-opening on PDP per client UX specification */
    }

    function showPostAtcStickyBar() {
      var postAtcBar = document.getElementById('PdpPostAtcBar');
      if (postAtcBar) {
        postAtcBar.classList.add('is-visible');
        postAtcBar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-post-atc-bar');
      }
    }
    window.showPostAtcStickyBar = showPostAtcStickyBar;

    function hidePostAtcStickyBar() {
      var postAtcBar = document.getElementById('PdpPostAtcBar');
      if (postAtcBar) {
        postAtcBar.classList.remove('is-visible');
        postAtcBar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-post-atc-bar');
      }
    }
    window.hidePostAtcStickyBar = hidePostAtcStickyBar;

    /* AJAX add-to-cart interceptor with in-button quantity management */
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // In qty mode, delegate the + and - clicks
        if (addToCartBtn.classList.contains('is-qty-mode')) {
          var targetPlus = e.target.closest('.qty-plus');
          var targetMinus = e.target.closest('.qty-minus');
          if (!targetPlus && !targetMinus) return;

          var curQty = parseInt((inBtnQtyVal && inBtnQtyVal.textContent) || '1', 10) || 1;

          if (targetPlus) {
            var newQty = curQty + 1;
            if (inBtnQtyVal) inBtnQtyVal.textContent = newQty;
            if (qtyDisplay) qtyDisplay.value = newQty;
            updateCartQuantity(newQty)
              .catch(function (err) {
                if (inBtnQtyVal) inBtnQtyVal.textContent = curQty;
                if (qtyDisplay) qtyDisplay.value = curQty;
                showToast(err.message || 'Could not update quantity', { error: true });
              });
            return;
          }

          if (targetMinus) {
            var newQty = curQty - 1;
            if (newQty <= 0) {
              revertInBtnQty();
              updateCartQuantity(0)
                .then(function () {
                  showToast('Removed from cart');
                  return fetch('/cart.js', { credentials: 'same-origin' });
                })
                .then(function (r) { return r ? r.json() : null; })
                .then(function (c) {
                  if (c) {
                    syncStateWithCartData(c);
                  } else {
                    hidePostAtcStickyBar();
                  }
                })
                .catch(function (err) {
                  renderInBtnQty(curQty);
                  showToast(err.message || 'Could not remove item', { error: true });
                });
            } else {
              if (inBtnQtyVal) inBtnQtyVal.textContent = newQty;
              if (qtyDisplay) qtyDisplay.value = newQty;
              updateCartQuantity(newQty)
                .catch(function (err) {
                  if (inBtnQtyVal) inBtnQtyVal.textContent = curQty;
                  if (qtyDisplay) qtyDisplay.value = curQty;
                  showToast(err.message || 'Could not update quantity', { error: true });
                });
            }
            return;
          }

          // In qty mode, tapping outside + and - does not trigger re-submission
          return;
        }

        // Standard Add to Cart submission
        if (matchingPairCb && matchingPairCb.checked && !matchingPairCb.disabled && !pairedVariantId) {
          showToast('Please select a size for the matching pair', { error: true });
          return;
        }

        var itemsToCart = [];
        var qty = Math.max(1, parseInt((qtyDisplay && qtyDisplay.value) || '1', 10) || 1);

        if (hasCustomSet) {
          var sel = findPairVariants();
          if (sel.radhaOn   && sel.radha)   itemsToCart.push({ id: Number(sel.radha.id),   quantity: qty });
          if (sel.krishnaOn && sel.krishna) itemsToCart.push({ id: Number(sel.krishna.id), quantity: qty });

          if (!itemsToCart.length) {
            showToast('Select at least one Poshak', { error: true });
            return;
          }
        } else {
          var v = findStandardVariant();
          var targetId = (v && v.id) || (variantIdInput && variantIdInput.value) || (productVariants && productVariants[0] && productVariants[0].id);
          if (!targetId) {
            showToast('Please select a variant', { error: true });
            return;
          }
          if (v && !v.available) {
            showToast('This item is currently sold out', { error: true });
            return;
          }
          itemsToCart.push({ id: Number(targetId), quantity: qty });
        }

        /* Check for "Complete the Pair" matching product checkbox */
        if (matchingPairCb && matchingPairCb.checked && !matchingPairCb.disabled && pairedVariantId) {
          itemsToCart.push({ id: Number(pairedVariantId), quantity: qty });
        }

        var prevLabel = addToCartText ? addToCartText.textContent.trim() : (isPreOrder ? 'Pre-Order' : 'Add To Cart');
        if (addToCartText) addToCartText.textContent = 'Adding…';
        addToCartBtn.setAttribute('disabled', '');
        addToCartBtn.disabled = true;

        postAddToCart(itemsToCart)
          .then(function (res) {
            if (!res.ok) {
              var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add to cart';
              throw new Error(msg);
            }
            refreshExternalCart();
            showPostAtcStickyBar();

            // Active/Added state: swap the ATC label for the in-button stepper
            renderInBtnQty(qty);
          })
          .catch(function (err) {
            showToast(err.message || 'Could not add to cart', { error: true });
            revertInBtnQty();
          });
      });

      addToCartBtn.addEventListener('keydown', function (e) {
        if (!addToCartBtn.classList.contains('is-qty-mode')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          var target = e.target.closest('.qty-plus') || e.target.closest('.qty-minus');
          if (target) {
            e.preventDefault();
            e.stopPropagation();
            target.click();
          }
        }
      });
    }

    /* Intercept form submit event */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (matchingPairCb && matchingPairCb.checked && !matchingPairCb.disabled && !pairedVariantId) {
          e.preventDefault();
          e.stopPropagation();
          showToast('Please select a size for the matching pair', { error: true });
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (addToCartBtn) {
          addToCartBtn.click();
        }
      });
    }

    /* Wire up Size / option radios (BOTH branches) */
    variantRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncVariantVisual();
        syncPickedLabels();
        updatePriceAndATC();
        var stdV = (!hasCustomSet) ? findStandardVariant() : null;
        syncVariantMedia(stdV, radio);
        requestAnimationFrame(positionDeityGuideArrow);
        setTimeout(positionDeityGuideArrow, 50);
      });
    });

    variantLabels.forEach(function (label) {
      label.addEventListener('click', function () {
        requestAnimationFrame(function () {
          positionDeityGuideArrow();
          setTimeout(positionDeityGuideArrow, 50);
        });
      });
    });

    /* Wire up Radha / Krishna checkboxes (pair branch ONLY) */
    if (hasCustomSet && pairContainer) {
      if (setRadhaCheckbox)   setRadhaCheckbox.addEventListener('change',   updatePriceAndATC);
      if (setKrishnaCheckbox) setKrishnaCheckbox.addEventListener('change', updatePriceAndATC);

      pairContainer.querySelectorAll('.checkbox-group').forEach(function (group) {
        group.addEventListener('click', function (e) {
          if (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL' || e.target.closest('label')) return;
          var cb = group.querySelector('input[type="checkbox"]');
          if (cb) {
            cb.checked = !cb.checked;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    /* Initial state */
    syncVariantVisual();
    syncPickedLabels();
    updatePriceAndATC();
    var initV = (!hasCustomSet) ? findStandardVariant() : null;
    var initCheckedColor = root.querySelector('[class*="__variant-radio"][data-option-name*="color"]:checked, [class*="__variant-radio"][data-option-name*="colour"]:checked');
    syncVariantMedia(initV, initCheckedColor);
    syncMatchingPair();
    syncButtonWithCart();
    if (matchingPairCb) {
      document.addEventListener('variant:change', syncMatchingPair);
    }
    requestAnimationFrame(positionDeityGuideArrow);
    setTimeout(positionDeityGuideArrow, 100);
    setTimeout(positionDeityGuideArrow, 300);

    window.addEventListener('resize', function () {
      requestAnimationFrame(positionDeityGuideArrow);
    });

    /* Cart sync: keep the sticky bar and button current across the store */
    document.addEventListener('cart:updated', function (e) {
      var cart = (e.detail && e.detail.cart) || null;
      if (cart) {
        syncStateWithCartData(cart);
      } else {
        syncProductWithCart();
      }
    });
    window.addEventListener('focus', syncProductWithCart);
    window.addEventListener('pageshow', syncProductWithCart);

    /* Open cart drawer on 'View Cart' click if drawer is enabled */
    var postAtcBarContainer = document.getElementById('PdpPostAtcBar');
    if (postAtcBarContainer) {
      var postAtcCartBtn = postAtcBarContainer.querySelector('.pdp-post-atc-bar__btn');
      if (postAtcCartBtn) {
        postAtcCartBtn.addEventListener('click', function (e) {
          if (window.DamodarCart && typeof window.DamodarCart.open === 'function') {
            e.preventDefault();
            window.DamodarCart.open();
          }
        });
      }
    }
    /* Luxury open/close for .stl-modal-quickview (shared with the
       complete-the-set snippet via window; first definition wins).
       `display: none` stays the CSS closed state; JS enables display,
       adds the animation class inside a double requestAnimationFrame,
       and only restores `display: none` 600ms after the exit starts. */
    if (typeof window.__stlModalOpen !== 'function') {
      window.__stlModalOpen = function (modal) {
        if (!modal) return;
        if (modal.__stlCloseTimer) {
          clearTimeout(modal.__stlCloseTimer);
          modal.__stlCloseTimer = null;
        }
        modal.classList.remove('is-closing');
        if (modal.classList.contains('is-open')) return;

        modal.style.display = 'flex';      /* 1) enable display */
        /* Modal history: Back closes the quick view through this same close fn. */
        if (window.DDModalHistory) window.DDModalHistory.notifyOpen(modal, function () { closeModal(modal); });
        void modal.offsetWidth;            /* flush the closed state so transitions run */
        if (modal.__stlOpenRaf) cancelAnimationFrame(modal.__stlOpenRaf);
        modal.__stlOpenRaf = requestAnimationFrame(function () {
          modal.__stlOpenRaf = requestAnimationFrame(function () {
            modal.__stlOpenRaf = null;     /* 2) double rAF -> animation class */
            modal.classList.add('is-open');
          });
        });
      };

      window.__stlModalClose = function (modal) {
        if (!modal) return;
        if (window.DDModalHistory) window.DDModalHistory.notifyClose(modal);
        /* Closed within the same frames it opened: cancel the pending open frames */
        if (modal.__stlOpenRaf) {
          cancelAnimationFrame(modal.__stlOpenRaf);
          modal.__stlOpenRaf = null;
          modal.classList.remove('is-open', 'is-closing');
          modal.style.display = '';
          return;
        }
        if (modal.__stlCloseTimer) return;                  /* close already in flight */
        if (!modal.classList.contains('is-open')) return;

        modal.classList.remove('is-open');                  /* 3) play exit transition */
        modal.classList.add('is-closing');
        modal.__stlCloseTimer = setTimeout(function () {    /* 4) 600ms -> display: none */
          modal.__stlCloseTimer = null;
          modal.classList.remove('is-closing');
          modal.style.display = '';
        }, 600);
      };
    }

    /* Full quick-view close (visual exit + aria + scroll unlock):
       shared by the close button, the backdrop dismiss and the
       modal-history Back handler. */
    function closeModal(modal) {
      if (!modal) return;
      if (typeof window.__stlModalClose === 'function') {
        window.__stlModalClose(modal);
      } else {
        modal.classList.remove('is-open');
      }
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('global-modal-locked');
      document.documentElement.classList.remove('global-modal-locked');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (typeof window.__productModalSavedScrollY === 'number' && window.__productModalSavedScrollY > 0) {
        var origScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo({ top: window.__productModalSavedScrollY, left: 0, behavior: 'auto' });
        requestAnimationFrame(function () {
          document.documentElement.style.scrollBehavior = origScrollBehavior;
        });
      }
    }

    /* Quick view modal open/close + WhatsApp size helper */
    document.addEventListener('click', function (e) {
      var waHelper = e.target.closest('[data-wa-size-helper], .size-whatsapp-helper');
      if (waHelper) {
        var globalWa = document.querySelector('.global-whatsapp-float');
        if (globalWa && globalWa.href) {
          e.preventDefault();
          window.open(globalWa.href, '_blank', 'noopener,noreferrer');
          return;
        }
      }

      var trigger = e.target.closest('.paired-image-trigger');
      if (trigger) {
        var modalId = trigger.getAttribute('data-stl-quickview-trigger');
        var handle = trigger.getAttribute('data-product-handle');
        var modal = null;
        if (modalId) {
          modal = document.getElementById(modalId);
        }
        if (!modal && handle) {
          modal = document.querySelector('[data-stl-modal][data-product-handle="' + CSS.escape(handle) + '"]');
        }
        if (modal) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window.sanitizeModalDescription === 'function') {
            window.sanitizeModalDescription(modal);
          }
          window.__productModalSavedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
          if (typeof window.__stlModalOpen === 'function') {
            window.__stlModalOpen(modal);
          } else {
            modal.classList.add('is-open');
          }
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('global-modal-locked');
          document.documentElement.classList.add('global-modal-locked');
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';
        }
        return;
      }

      var closeBtn = e.target.closest('[data-stl-modal-close], .stl-modal-quickview-close, .set-modal-close-icon');
      if (closeBtn) {
        e.preventDefault();
        var targetModal = closeBtn.closest('.stl-modal-quickview, [data-stl-modal]');
        if (targetModal) {
          closeModal(targetModal);
        }
        return;
      }

      if (e.target.classList.contains('stl-modal-quickview')) {
        closeModal(e.target);
      }
    });

    /* Quick view modal description sanitizer */
    function sanitizeModalDescription(modal) {
      if (!modal) return;
      var textEls = modal.querySelectorAll('.set-modal-info-text');
      textEls.forEach(function (el) {
        el.querySelectorAll('li').forEach(function(li) {
          if (!li.textContent.trim()) li.remove();
        });

        if (el.querySelector('ol, ul')) {
          return;
        }

        var pTags = el.querySelectorAll('p');
        pTags.forEach(function(p) {
          var match = p.innerHTML.match(/^(\s*<strong[^>]*>)?(\d+[\.\)])(\s*<\/strong>)?\s*(.*)$/i);
          if (match && !p.querySelector('.accordion-num')) {
            var num = match[2];
            var rest = match[4] || '';
            p.innerHTML = '<span class="accordion-num">' + num + '</span> ' + rest;
          }
        });
      });
    }
    window.sanitizeModalDescription = sanitizeModalDescription;

    // Track swipe/scroll on modal image track to update dots
    document.addEventListener('scroll', function (e) {
      var track = e.target;
      if (!track || !track.classList || !track.classList.contains('set-modal-slider-track')) return;
      var modal = track.closest('.stl-modal-quickview');
      if (!modal) return;
      var dots = modal.querySelectorAll('.set-modal-dot');
      if (!dots.length) return;
      var slideWidth = track.clientWidth || 1;
      var activeIdx = Math.round(track.scrollLeft / slideWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIdx);
      });
    }, true);

    // Click dot to navigate slides
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.set-modal-dot');
      if (!dot) return;
      var modal = dot.closest('.stl-modal-quickview');
      if (!modal) return;
      var track = modal.querySelector('.set-modal-slider-track');
      if (!track) return;
      var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
      if (isNaN(idx)) return;
      var slideWidth = track.clientWidth || 1;
      track.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
    });

    // Zoom Button or Modal Slide Image Click
    document.addEventListener('click', function (e) {
      var zoomTrigger = e.target.closest('.set-modal-zoom-btn') || e.target.closest('.set-modal-slide img');
      if (zoomTrigger) {
        e.preventDefault();
        e.stopPropagation();
        var modal = zoomTrigger.closest('.stl-modal-quickview');
        if (modal && typeof window.openProductLightbox === 'function') {
          var imagesDataEl = modal.querySelector('[data-images-json]');
          var imagesList = [];
          if (imagesDataEl) {
            try { imagesList = JSON.parse(imagesDataEl.textContent); } catch (err) {}
          }
          var track = modal.querySelector('[data-slider-track]');
          var currentIdx = 0;
          if (track) {
            var sWidth = track.clientWidth || 1;
            currentIdx = Math.round(track.scrollLeft / sWidth);
          }
          var activeItem = imagesList[currentIdx] || imagesList[0];
          if (activeItem) {
            window.openProductLightbox(activeItem.zoom || activeItem.src, activeItem.alt || 'Product Image', zoomTrigger, imagesList, currentIdx);
          }
        }
      }
    });

    // Checkbox toggle inside modal (Customize Your Set)
    document.addEventListener('change', function (e) {
      var cb = e.target.closest('.set-modal-piece-cb');
      if (!cb) return;

      var modal = cb.closest('.stl-modal-quickview');
      if (!modal) return;

      var group = cb.closest('.checkbox-group');
      if (group) {
        group.classList.toggle('is-checked', cb.checked);
      }

      var radhaCb = modal.querySelector('.set-modal-piece-cb[data-piece="radha"]');
      var krishnaCb = modal.querySelector('.set-modal-piece-cb[data-piece="krishna"]');
      var radhaChecked = radhaCb ? radhaCb.checked : false;
      var krishnaChecked = krishnaCb ? krishnaCb.checked : false;

      var submitBtn = modal.querySelector('.set-modal-submit-btn');
      var guidanceEl = modal.querySelector('[data-modal-guidance]');
      var activeSizeVal = modal.getAttribute('data-active-size-val');

      if (activeSizeVal && window.ShringarHub && typeof window.ShringarHub.notifySetSelected === 'function') {
        var modalProdId = modal.id.replace('stl-quickview-modal-', '');
        var titleEl = modal.querySelector('.set-modal-title') || modal.querySelector('.stl-modal-quickview-title');
        var modalProdTitle = modal.getAttribute('data-product-title') || (titleEl ? titleEl.textContent.trim() : '');
        var rId = modal.getAttribute('data-active-radha-id');
        var kId = modal.getAttribute('data-active-krishna-id');
        window.ShringarHub.notifySetSelected(modalProdId, {
          isPair: true,
          radhaId: rId,
          krishnaId: kId,
          radhaOn: radhaChecked,
          krishnaOn: krishnaChecked
        }, modalProdTitle, activeSizeVal, (radhaChecked || krishnaChecked));
      }

      if (!radhaChecked && !krishnaChecked) {
        if (guidanceEl) guidanceEl.textContent = 'Select at least one Poshak';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.remove('is-ready');
          submitBtn.textContent = 'Select at least one Poshak';
        }
        return;
      }

      if (activeSizeVal) {
        var radhaPriceNum = Number(modal.getAttribute('data-active-radha-price-num')) || 0;
        var krishnaPriceNum = Number(modal.getAttribute('data-active-krishna-price-num')) || 0;
        var totalCents = (radhaChecked ? radhaPriceNum : 0) + (krishnaChecked ? krishnaPriceNum : 0);
        var rupees = Math.round(totalCents / 100);
        var totalFormatted = '₹' + rupees.toLocaleString('en-IN');

        if (guidanceEl) {
          guidanceEl.textContent = totalFormatted;
          guidanceEl.classList.add('has-price');
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.add('is-ready');
          submitBtn.innerHTML = 'Add to Cart &bull; ' + totalFormatted;
        }
      } else {
        if (guidanceEl) guidanceEl.textContent = 'Select a size to see the price';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.remove('is-ready');
          var isPairSet = modal.getAttribute('data-is-pair-set') === 'true' || submitBtn.getAttribute('data-is-pair-set') === 'true';
          submitBtn.textContent = isPairSet ? 'Select Idol Height' : 'Select Size';
        }
      }
    });

    // Variant Pill Click Inside Modal
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.set-modal-pill');
      if (pill) {
        e.preventDefault();
        var modal = pill.closest('.stl-modal-quickview');
        if (!modal) return;
        var pillsList = pill.closest('.set-modal-pills-list');
        if (pillsList) {
          pillsList.querySelectorAll('.set-modal-pill').forEach(function (p) {
            p.classList.remove('is-selected');
          });
        }
        pill.classList.add('is-selected');

        var isPairSize = pill.getAttribute('data-is-pair-size') === 'true';
        if (isPairSize) {
          var sizeVal = pill.getAttribute('data-size-val');
          var radhaId = pill.getAttribute('data-radha-id');
          var krishnaId = pill.getAttribute('data-krishna-id');
          var radhaPrice = pill.getAttribute('data-radha-price');
          var krishnaPrice = pill.getAttribute('data-krishna-price');
          var radhaPriceNum = Number(pill.getAttribute('data-radha-price-num')) || 0;
          var krishnaPriceNum = Number(pill.getAttribute('data-krishna-price-num')) || 0;
          var combinedPriceStr = pill.getAttribute('data-combined-price');

          modal.setAttribute('data-active-size-val', sizeVal);
          modal.setAttribute('data-active-radha-id', radhaId || '');
          modal.setAttribute('data-active-krishna-id', krishnaId || '');
          modal.setAttribute('data-active-radha-price-num', radhaPriceNum);
          modal.setAttribute('data-active-krishna-price-num', krishnaPriceNum);
          modal.setAttribute('data-active-radha-price', radhaPrice || '');
          modal.setAttribute('data-active-krishna-price', krishnaPrice || '');

          var radhaPriceEl = modal.querySelector('[data-modal-piece-price="radha"]');
          var krishnaPriceEl = modal.querySelector('[data-modal-piece-price="krishna"]');
          if (radhaPriceEl && radhaPrice) radhaPriceEl.textContent = radhaPrice;
          if (krishnaPriceEl && krishnaPrice) krishnaPriceEl.textContent = krishnaPrice;

          var radhaCb = modal.querySelector('.set-modal-piece-cb[data-piece="radha"]');
          var krishnaCb = modal.querySelector('.set-modal-piece-cb[data-piece="krishna"]');
          var radhaChecked = radhaCb ? radhaCb.checked : false;
          var krishnaChecked = krishnaCb ? krishnaCb.checked : false;

          var submitBtn = modal.querySelector('.set-modal-submit-btn');
          var guidanceEl = modal.querySelector('[data-modal-guidance]');

          if (!radhaChecked && !krishnaChecked) {
            if (guidanceEl) guidanceEl.textContent = 'Select at least one Poshak';
            if (submitBtn) {
              submitBtn.disabled = true;
              submitBtn.classList.remove('is-ready');
              submitBtn.textContent = 'Select at least one Poshak';
            }
          } else {
            var totalCents = (radhaChecked ? radhaPriceNum : 0) + (krishnaChecked ? krishnaPriceNum : 0);
            var rupees = Math.round(totalCents / 100);
            var totalFormatted = '₹' + rupees.toLocaleString('en-IN');

            if (guidanceEl) {
              guidanceEl.textContent = totalFormatted;
              guidanceEl.classList.add('has-price');
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.add('is-ready');
              submitBtn.setAttribute('data-is-pair-set', 'true');
              submitBtn.innerHTML = 'Add to Cart &bull; ' + totalFormatted;
            }
          }

          // Sync with card dropdown (Complete the Set)
          var cardId = modal.id.replace('stl-quickview-modal-', '');
          var card = document.querySelector('.complete-the-set-card[data-product-card-id="' + cardId + '"]');
          if (card) {
            var select = card.querySelector('.set-card-select');
            if (select) select.value = sizeVal;
            if (typeof window.syncCardCustomTrigger === 'function') {
              window.syncCardCustomTrigger(card);
            }
            var cBtn = card.querySelector('.set-select-size-btn');
            if (cBtn) {
              cBtn.setAttribute('data-is-pair-set', 'true');
              cBtn.setAttribute('data-radha-id', radhaId);
              cBtn.setAttribute('data-krishna-id', krishnaId);
              cBtn.setAttribute('data-selected-size', sizeVal);
              cBtn.classList.add('is-ready');
              cBtn.innerHTML = 'Add to Cart &bull; ' + combinedPriceStr;
            }
          }

          // Notify ShringarHub
          var modalProdId = modal.id.replace('stl-quickview-modal-', '');
          var titleEl = modal.querySelector('.set-modal-title') || modal.querySelector('.stl-modal-quickview-title');
          var modalProdTitle = modal.getAttribute('data-product-title') || (titleEl ? titleEl.textContent.trim() : '');
          var sizeTitle = pill.getAttribute('data-size-title') || pill.textContent.trim();
          if (window.ShringarHub && typeof window.ShringarHub.notifySetSelected === 'function') {
            window.ShringarHub.notifySetSelected(modalProdId, {
              isPair: true,
              radhaId: radhaId,
              krishnaId: krishnaId,
              radhaOn: radhaChecked,
              krishnaOn: krishnaChecked
            }, modalProdTitle, sizeTitle, (radhaChecked || krishnaChecked));
          }
          return;
        }

        var variantId = pill.getAttribute('data-variant-id');
        var variantPrice = pill.getAttribute('data-variant-price');

        var guidanceEl = modal.querySelector('[data-modal-guidance]');
        if (guidanceEl && variantPrice) {
          guidanceEl.textContent = variantPrice;
          guidanceEl.classList.add('has-price');
        }

        var submitBtn = modal.querySelector('.set-modal-submit-btn');
        if (submitBtn) {
          submitBtn.setAttribute('data-selected-variant-id', variantId);
          submitBtn.removeAttribute('data-is-pair-set');
          submitBtn.classList.add('is-ready');
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Add to Cart &bull; ' + (variantPrice || '');
        }

        // Sync with card dropdown (Complete the Set)
        var handle = modal.getAttribute('data-product-handle');
        if (handle) {
          var card = document.querySelector('.complete-the-set-card[data-product-card-id="' + modal.id.replace('stl-quickview-modal-', '') + '"]');
          if (card) {
            var select = card.querySelector('.set-card-select');
            if (select) {
              select.value = variantId;
              if (typeof window.syncCardCustomTrigger === 'function') {
                window.syncCardCustomTrigger(card);
              }
              var cBtn = card.querySelector('.set-select-size-btn');
              if (cBtn) {
                cBtn.setAttribute('data-selected-variant-id', variantId);
                cBtn.removeAttribute('data-is-pair-set');
                cBtn.classList.add('is-ready');
                cBtn.innerHTML = 'Add to Cart &bull; ' + (variantPrice || '');
              }
            }
          }
        }

        // Sync with Complete the Pair (product-configurator) if present
        var pairedPill = document.querySelector('.paired-size-pill[data-variant-id="' + variantId + '"]');
        if (pairedPill) {
          pairedPill.click();
        }

        // Notify ShringarHub
        var modalProdId = modal.id.replace('stl-quickview-modal-', '');
        var titleEl = modal.querySelector('.set-modal-title') || modal.querySelector('.stl-modal-quickview-title');
        var modalProdTitle = modal.getAttribute('data-product-title') || (titleEl ? titleEl.textContent.trim() : '');
        var variantTitle = pill.getAttribute('data-variant-title') || pill.textContent.trim();
        if (window.ShringarHub && typeof window.ShringarHub.notifySetSelected === 'function') {
          window.ShringarHub.notifySetSelected(modalProdId, variantId, modalProdTitle, variantTitle, true);
        }
      }
    });

    // Modal Submit / Add to Cart Click Inside Modal
    document.addEventListener('click', function (e) {
      var modalSubmitBtn = e.target.closest('.set-modal-submit-btn');
      if (modalSubmitBtn) {
        e.preventDefault();
        var modal = modalSubmitBtn.closest('.stl-modal-quickview');
        if (!modal) return;

        if (modalSubmitBtn.disabled || modalSubmitBtn.dataset.busy === 'true') return;

        var isPair = modalSubmitBtn.getAttribute('data-is-pair-set') === 'true';

        if (isPair) {
          var activeSize = modal.getAttribute('data-active-size-val');
          if (!activeSize) {
            var pillsList = modal.querySelector('.set-modal-pills-list');
            if (pillsList) {
              pillsList.scrollIntoView({ behavior: 'smooth', block: 'center' });
              pillsList.style.outline = '2px solid #5A1A2B';
              setTimeout(function () { pillsList.style.outline = ''; }, 1200);
            }
            return;
          }

          var radhaCb = modal.querySelector('.set-modal-piece-cb[data-piece="radha"]');
          var krishnaCb = modal.querySelector('.set-modal-piece-cb[data-piece="krishna"]');
          var radhaChecked = radhaCb ? radhaCb.checked : false;
          var krishnaChecked = krishnaCb ? krishnaCb.checked : false;

          var itemsToCart = [];
          if (radhaChecked) {
            var rId = modal.getAttribute('data-active-radha-id');
            if (rId) itemsToCart.push({ id: Number(rId), quantity: 1 });
          }
          if (krishnaChecked) {
            var kId = modal.getAttribute('data-active-krishna-id');
            if (kId) itemsToCart.push({ id: Number(kId), quantity: 1 });
          }

          if (!itemsToCart.length) {
            var toast = document.querySelector('[data-cart-toast]');
            if (toast) {
              toast.textContent = 'Select at least one Poshak';
              toast.classList.add('is-error');
              toast.classList.add('is-visible');
              setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
            }
            return;
          }

          if (window.ShringarHub && typeof window.ShringarHub.notifySetSelected === 'function') {
            var modalProdId = modal.id.replace('stl-quickview-modal-', '');
            var titleEl = modal.querySelector('.set-modal-title') || modal.querySelector('.stl-modal-quickview-title');
            var modalProdTitle = modal.getAttribute('data-product-title') || (titleEl ? titleEl.textContent.trim() : '');
            window.ShringarHub.notifySetSelected(modalProdId, {
              isPair: true,
              radhaId: modal.getAttribute('data-active-radha-id'),
              krishnaId: modal.getAttribute('data-active-krishna-id'),
              radhaOn: radhaChecked,
              krishnaOn: krishnaChecked
            }, modalProdTitle, activeSize, true);
          }

          modalSubmitBtn.dataset.busy = 'true';
          var origModalHtml = modalSubmitBtn.innerHTML;
          modalSubmitBtn.disabled = true;
          modalSubmitBtn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ items: itemsToCart })
          })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && (data.description || data.message)) || 'Could not add item');
              });
            }
            return res.json();
          })
          .then(function () {
            delete modalSubmitBtn.dataset.busy;
            if (typeof window.refreshCartUI === 'function') {
              window.refreshCartUI();
            } else {
              fetch('/cart.js', { credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  if (!cart) return;
                  var countEls = document.querySelectorAll('[data-cart-count]');
                  countEls.forEach(function (el) { el.textContent = cart.item_count; });
                })
                .catch(function () {});
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }

            var toast = document.querySelector('[data-cart-toast]');
            if (toast) {
              toast.textContent = 'Added to cart';
              toast.classList.remove('is-error');
              toast.classList.add('is-visible');
              setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
            }

            modalSubmitBtn.textContent = 'Added \u2713';
            modalSubmitBtn.classList.add('is-added');

            setTimeout(function () {
              modalSubmitBtn.disabled = false;
              modalSubmitBtn.innerHTML = origModalHtml;
              modalSubmitBtn.classList.remove('is-added');
              var targetModal = modalSubmitBtn.closest('.stl-modal-quickview');
              if (targetModal) {
                if (typeof window.__stlModalClose === 'function') {
                  window.__stlModalClose(targetModal);
                } else {
                  targetModal.classList.remove('is-open');
                }
                targetModal.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('global-modal-locked');
                document.documentElement.classList.remove('global-modal-locked');
                document.body.style.overflow = '';
                document.documentElement.style.overflow = '';
              }
            }, 1200);
          })
          .catch(function (err) {
            delete modalSubmitBtn.dataset.busy;
            var toast = document.querySelector('[data-cart-toast]');
            if (toast) {
              toast.textContent = err.message || 'Could not add item';
              toast.classList.add('is-error');
              toast.classList.add('is-visible');
              setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
            }
            modalSubmitBtn.textContent = 'Error';
            setTimeout(function () {
              modalSubmitBtn.disabled = false;
              modalSubmitBtn.innerHTML = origModalHtml;
            }, 2000);
          });
          return;
        }

        // Standard non-pair product
        var mVariantId = modalSubmitBtn.getAttribute('data-selected-variant-id');
        if (!mVariantId) {
          var pillsList = modal.querySelector('.set-modal-pills-list');
          if (pillsList) {
            pillsList.scrollIntoView({ behavior: 'smooth', block: 'center' });
            pillsList.style.outline = '2px solid #5A1A2B';
            setTimeout(function () { pillsList.style.outline = ''; }, 1200);
          }
          return;
        }

        modalSubmitBtn.dataset.busy = 'true';
        var origModalHtml = modalSubmitBtn.innerHTML;
        modalSubmitBtn.disabled = true;
        modalSubmitBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: Number(mVariantId),
            quantity: 1
          })
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error((data && (data.description || data.message)) || 'Could not add item');
            });
          }
          return res.json();
        })
        .then(function () {
          delete modalSubmitBtn.dataset.busy;
          if (typeof window.refreshCartUI === 'function') {
            window.refreshCartUI();
          } else {
            fetch('/cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (!cart) return;
                var countEls = document.querySelectorAll('[data-cart-count]');
                countEls.forEach(function (el) { el.textContent = cart.item_count; });
              })
              .catch(function () {});
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }

          var toast = document.querySelector('[data-cart-toast]');
          if (toast) {
            toast.textContent = 'Added to cart';
            toast.classList.remove('is-error');
            toast.classList.add('is-visible');
            setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
          }

          modalSubmitBtn.textContent = 'Added \u2713';
          modalSubmitBtn.classList.add('is-added');

          setTimeout(function () {
            modalSubmitBtn.disabled = false;
            modalSubmitBtn.innerHTML = origModalHtml;
            modalSubmitBtn.classList.remove('is-added');
            var targetModal = modalSubmitBtn.closest('.stl-modal-quickview');
            if (targetModal) {
              if (typeof window.__stlModalClose === 'function') {
                window.__stlModalClose(targetModal);
              } else {
                targetModal.classList.remove('is-open');
              }
              targetModal.setAttribute('aria-hidden', 'true');
              document.body.classList.remove('global-modal-locked');
              document.documentElement.classList.remove('global-modal-locked');
              document.body.style.overflow = '';
              document.documentElement.style.overflow = '';
            }
          }, 1200);
        })
        .catch(function (err) {
          delete modalSubmitBtn.dataset.busy;
          var toast = document.querySelector('[data-cart-toast]');
          if (toast) {
            toast.textContent = err.message || 'Could not add item';
            toast.classList.add('is-error');
            toast.classList.add('is-visible');
            setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
          }
          modalSubmitBtn.textContent = 'Error';
          setTimeout(function () {
            modalSubmitBtn.disabled = false;
            modalSubmitBtn.innerHTML = origModalHtml;
          }, 2000);
        });
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.stl-modal-quickview').forEach(sanitizeModalDescription);
      });
    } else {
      document.querySelectorAll('.stl-modal-quickview').forEach(sanitizeModalDescription);
    }

    /* Add to Cart shine - plays on load and triggers on scroll */
    (function atcShineOnScroll() {
      var buttons = document.querySelectorAll('.btn-pdp-add-to-cart, .atc, .add-to-cart-btn');
      if (!buttons.length) return;

      var motionQuery = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;
      if (motionQuery && motionQuery.matches) return;

      var isBusy = false;
      var lastTrigger = 0;
      var useAlt = false;

      function triggerShine(btn) {
        if (!btn) return;
        var now = Date.now();
        if (isBusy || (now - lastTrigger < 2000)) return;

        var rect = btn.getBoundingClientRect();
        var vH = window.innerHeight || document.documentElement.clientHeight || 0;
        var inView = rect.top < vH && rect.bottom > 0 && rect.width > 0 && rect.height > 0;
        if (!inView) return;

        isBusy = true;
        lastTrigger = now;

        btn.classList.remove('is-shining', 'is-shining-alt');
        void btn.offsetWidth;

        useAlt = !useAlt;
        btn.classList.add(useAlt ? 'is-shining-alt' : 'is-shining');

        setTimeout(function () {
          btn.classList.remove('is-shining', 'is-shining-alt');
          isBusy = false;
        }, 1200);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              triggerShine(entry.target);
            }
          });
        }, { threshold: [0.1, 0.25, 0.5] });

        buttons.forEach(function (btn) {
          observer.observe(btn);
        });
      }

      var scrollTimer = null;
      window.addEventListener('scroll', function () {
        if (scrollTimer) return;
        scrollTimer = setTimeout(function () {
          scrollTimer = null;
          buttons.forEach(function (btn) {
            triggerShine(btn);
          });
        }, 150);
      }, { passive: true });
    })();
  })();

